import { useState } from 'react'

export function MobileDeviceNotice() {
  const [continueOnMobile, setContinueOnMobile] = useState(false)

  if (continueOnMobile) {
    return null
  }

  return (
    <section
      className="fixed inset-0 z-[100] flex min-h-dvh flex-col overflow-y-auto bg-background px-6 text-center md:hidden"
      aria-labelledby="mobile-notice-title"
    >
      <div className="mx-auto flex w-full max-w-sm flex-1 flex-col items-center justify-center py-12">
        <img
          src="/brand/mill-box-logo.png"
          alt="Mill-Box"
          width={180}
          height={33}
          className="mb-14 h-auto w-44"
          fetchPriority="high"
        />

        <h1
          id="mobile-notice-title"
          className="text-balance text-2xl font-black leading-relaxed tracking-tight text-foreground"
        >
          管理画面はスマートフォン向けに
          <br />
          最適化されていません
        </h1>

        <p className="mt-7 text-pretty text-base font-medium leading-8 text-muted-foreground">
          Mill-Box管理画面はパソコンでのご利用を推奨しています。
          <br />
          現場スキャンをご利用の方は、スマホ向けアプリをご利用ください。
        </p>

        <a
          href="mill-box://"
          className="mt-10 inline-flex min-h-14 w-full items-center justify-center rounded-xl bg-primary px-6 text-lg font-bold text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ring/30"
        >
          スマホ向けアプリを開く
        </a>

        <button
          type="button"
          onClick={() => {
            setContinueOnMobile(true)
          }}
          className="mt-7 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground/70 underline-offset-4 hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          PC機能をスマホ（タブレット）から使う
        </button>
      </div>
    </section>
  )
}
